import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from 'utils/utils';
import { BizCategory } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';

const cx = classNames.bind('./index.scss');
export interface CompanySearchBoxProp {}

const CompanySearchBox = ({}: CompanySearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();

  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [biz, setBiz] = useState<number>();

  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setBiz(0);
    navigate(location.pathname);
  };

  const onSearch = (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { search: value, pageNo: 1 }),
    });    
  };

  const onChangeCategory= (value: string) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { biz: value, pageNo: 1 }),
    }); 
    /*

    */
  };  
  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const historySearch = getQueryString(location.search);
    if (historySearch.search) setSearchInput(historySearch.search);
    if (historySearch.biz) setBiz(historySearch.biz);
    
  }, [location.search]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space>        
        <BizCategory defaultValue={biz} onChangeSelect={onChangeCategory} />
        <Input.Search
          className={cx('searchInput')}
          value={searchInput}
          placeholder="기업명,CRM,프로젝트명 검색"
          onChange={onChange}
          onSearch={onSearch}
          allowClear

        />
        <Button onClick={onClickReset}>
          검색초기화
        </Button>                
      </Space>
    </div>
  );
};

export default CompanySearchBox;
